import { Button } from "antd";

const ButtonExportExcel = ({ onClick }) => {
  // const onClick = () => {
  //   console.log("Excel Print");
  // };

  return (
    <div>
      <Button
        size="large"
        className="bg-green-600 text-white py-2 px-4 rounded-md mb-4"
        onClick={onClick}
      >
        Export Excel
      </Button>
    </div>
  );
};

export default ButtonExportExcel;
